import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const additionalSupportApi = createApi({
  reducerPath: 'additionalSupport',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['AdditionalSupport'],
  endpoints: (builder) => ({
    getAllAdditionalSupport: builder.query({
      query: () => 'accountSetup/supportNeeds',
      transformResponse: (res) => res.data,
      providesTags: ['AdditionalSupport'],
    }),
    addNewAdditionalSupport: builder.mutation({
      query: (data) => ({
        url: `accountSetup/supportNeeds`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags: ['AdditionalSupport'],
    }),
    updateAdditionalSupport: builder.mutation({
      query: ({ id, data }) => ({
        url: `accountSetup/supportNeeds/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags: ['AdditionalSupport'],
    }),
    deleteAdditionalSupport: builder.mutation({
      query: (id) => ({
        url: `accountSetup/supportNeeds/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AdditionalSupport'],
    }),
  }),
});

export const {
  useGetAllAdditionalSupportQuery,
  useAddNewAdditionalSupportMutation,
  useUpdateAdditionalSupportMutation,
  useDeleteAdditionalSupportMutation,
} = additionalSupportApi;
